<template>
	<div class="primary-main bank-main school-manage" v-loading="loading">
		<div class="search">
      <el-select v-model="zhzt" :popper-append-to-body="false" filterable placeholder="账号状态" clearable style="width: 12%;">
				<el-option value="0" label="已禁用">已禁用</el-option>
				<el-option value="1" label="启用中">启用中</el-option>
			</el-select>
			<el-input v-model="jgmc" placeholder="机构、机构id、负责人、手机号" clearable style="width: 290px;margin-bottom: 10px;"></el-input>
			<el-button @click="searchJgglPage" style="margin-bottom: 10px;" icon="el-icon-search">查询</el-button>
      <el-button type="primary" @click="jgglExport" style="margin-bottom: 10px;" icon="el-icon-download">导出</el-button>
      <el-button type="primary" @click="showSaveJggl()" style="margin-bottom: 10px;" icon="el-icon-plus">新增</el-button>
		</div>
		<el-table :data="tableData" border :header-cell-style="{ 'text-align': 'center' }"
			:cell-style="{ 'text-align': 'center' }" style="width: 100%">
			<el-table-column type="index" label="序号" width="80"></el-table-column>
			<el-table-column prop="jgbm" label="机构编码" width="100"></el-table-column>
			<el-table-column prop="jgmc" label="机构"></el-table-column>
			<el-table-column prop="jglxmc" label="机构类型" width="80"></el-table-column>
			<el-table-column label="业务名称" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.ywList && scope.row.ywList.length">
            <span v-for="(item, index) in scope.row.ywList" :key="index">
              {{ item.ywmc || getYwName(item.ywcode) }}（{{ item.rs }}人）<i v-if="index!=scope.row.ywList.length-1">，</i>
            </span>
          </span>
        </template>
      </el-table-column>
			<el-table-column prop="fzr" label="负责人"></el-table-column>
			<el-table-column prop="sjh" label="手机号" width="120"></el-table-column>
			<el-table-column prop="sxjf" label="开通app每个学生每天所需积分"></el-table-column>
			<el-table-column prop="dz" label="地址"></el-table-column>
			<el-table-column label="账户余额积分" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.ywList && scope.row.ywList.length">
            <span v-for="(item, index) in scope.row.ywList" :key="index">
              {{ item.ywmc || getYwName(item.ywcode) }}：{{ item.zhyejf }}<i v-if="index!=scope.row.ywList.length-1">，</i>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="账户状态" width="80">
        <template slot-scope="scope">
          <el-tag size="mini" v-if="scope.row.zhzt==1">启用中</el-tag>
          <el-tag size="mini" v-if="scope.row.zhzt==0" type="danger">已禁用</el-tag>
        </template>
      </el-table-column>
			<el-table-column label="操作" width="150">
				<template slot-scope="scope">
					<!-- <el-button type="text" @click="showJgJfList(scope.row.id)">积分记录</el-button> -->
          <el-button type="text" @click="showSaveJggl(scope.row.id)">编辑</el-button>
          <el-button type="text" @click="jgglDel(scope.row.id)" v-if="scope.row.zhzt==0">删除</el-button>
          <el-button type="text" @click="jgglZtEdit(scope.row.id,1)" v-if="scope.row.zhzt==0">启用</el-button>
          <el-button type="text" @click="jgglZtEdit(scope.row.id,0)" v-if="scope.row.zhzt==1">禁用</el-button>
        </template>
			</el-table-column>
		</el-table>
		<el-pagination
        v-if="tableData.length"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total">
		</el-pagination>

    <el-dialog
        :title="isAdd?'新增':'详情'"
        :visible.sync="jgglSaveDialog"
        width="500px"
        :before-close="handleClose"
        :close-on-click-modal="false">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="135px">
<!--				<el-form-item label="机构编码：" prop="jgbm">
				  <el-input v-model="ruleForm.jgbm" placeholder="请输入机构编码" maxlength="30" show-word-limit></el-input>
				</el-form-item>-->
        <el-form-item label="机构名称：" prop="jgmc">
          <el-input v-model="ruleForm.jgmc" placeholder="请输入机构名称" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="机构类型：" prop="jglxId">
          <el-select v-model="ruleForm.jglxId" :disabled="ruleForm.id!==''&&ruleForm.id!==null&&ruleForm.id!=undefined" :popper-append-to-body="false" clearable filterable placeholder="机构类型" style="width: 100%;">
            <el-option v-for="item in jglxList" :key="item.id" :label="item.lxmc" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="负责人：" prop="fzr">
          <el-input v-model="ruleForm.fzr" placeholder="请输入负责人" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="sjh">
          <el-input v-model="ruleForm.sjh" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="开通app每个学生每天所需积分：" prop="sxjf">
          <el-input v-model="ruleForm.sxjf" placeholder="请输入开通app每个学生每天所需积分"></el-input>
        </el-form-item>
        <el-form-item label="业务：" prop="ywList">
          <el-checkbox-group v-model="selectedYwIds" @change="handleYwChange">
            <el-checkbox v-for="item in ywList" :key="item.id" :label="item.ywcode" :disabled="isEdit && originalYwIds.includes(item.ywcode)">{{ item.ywmc }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="业务人数：" v-if="selectedYwIds.length > 0">
          <div v-for="ywcode in selectedYwIds" :key="ywcode" style="margin-bottom: 10px;">
            <span style="display: inline-block; width: 150px;">{{ getYwName(ywcode) }}：</span>
            <el-input-number v-model="ywRsMap[ywcode]" :min="0" :max="100000" label="人数" style="width: 150px;"></el-input-number>
          </div>
        </el-form-item>
				<el-form-item label="地址：" prop="dz">
				  <el-input type="textarea" v-model="ruleForm.dz" placeholder="请输入地址" maxlength="200" show-word-limit></el-input>
				</el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="jgglSave">确 定</el-button>
      </span>
    </el-dialog>
	</div>
</template>

<script>
export default {
	name: 'jgglList',
	data() {
		return {
			userType: sessionStorage.getItem("userType"),
      jgglSaveDialog: false,
			jglxList: [],  // 机构类型
			dlsglId: sessionStorage.getItem("dlsglId"), // 代理商id
      zhzt: '',//账户状态
      jgmc: '',//代理商名称
      curDate: new Date().getTime(),
			tableData: [],
			page: { page: 1, size: 10, total: 0 },
			loading: false,
			isAdd: false,
      ywList: [], // 业务列表
      selectedYwIds: [], // 选中的业务ID列表
      originalYwIds: [], // 编辑时原始选中的业务ID列表
      isEdit: false, // 是否是编辑模式
      ywRsMap: {}, // 业务人数映射 {ywcode: rs}
      ruleForm: {
				//jgbm: '',
				jgmc: '',
				jglxId: '',
				jglxmc: '',
        fzr: '',
        sjh: '',
				dz: '',
        sxjf: 0,
				dlsglId: sessionStorage.getItem("dlsglId"),
        ywList: []
      },
      rules: {
				/*jgbm: [
					{ required: true, message: '请输入机构编码', trigger: 'blur' }
				],*/
        jgmc: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        jglxId: [
          { required: true, message: '请选择机构类型', trigger: 'blur' }
        ],
        fzr: [
          { required: true, message: '请输入负责人', trigger: 'blur' }
        ],
        sjh: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            validator: (rule, value, callback) => { // 使用箭头函数绑定上下文
              this.validatePhone(rule, value, callback)
            },
            trigger: 'blur'
          }
        ],
        sxjf: [
          { required: true, message: '请输入开通app每个学生每天所需积分', trigger: 'blur' }
        ],
        ywList: [
          { required: true, message: '请选择业务', trigger: 'change' }
        ]
      }
		}
	},
  components:{},
	created() {
		this.sltData();
		//获取代理商机构分页列表
		this.findJgglPage();
	},
	methods: {
    // 业务选择变化
    handleYwChange(ywIds) {
      // 初始化新选择业务的人数
      ywIds.forEach(ywId => {
        if (!this.ywRsMap[ywId]) {
          this.$set(this.ywRsMap, ywId, 0);
        }
      });
      // 清除未选业务的rs
      Object.keys(this.ywRsMap).forEach(key => {
        if (!ywIds.includes(key)) {
          this.$delete(this.ywRsMap, key);
        }
      });
      // 手动触发校验
      this.ruleForm.ywList = ywIds;
      this.$refs.ruleForm.validateField('ywList');
    },
    // 根据业务ID获取业务名称
    getYwName(ywcode) {
      const yw = this.ywList.find(item => item.ywcode === ywcode);
      return yw ? yw.ywmc : '';
    },
    validatePhone(rule, value, callback) {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    },
    // 下拉列表数据
    sltData() {
      var _this = this;
      // 代理商机构列表
      //var params = {dlsglId: _this.dlsglId};
      _this.$post("jggl/JgglController/jglxList").then(rep => {
        if (rep.code == 1) {
          _this.jglxList = rep.result.list;
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
      // 业务列表 - 从 dlsglDetail 接口获取
      this.$post("jggl/JgglController/dlsglDetail", { id: _this.dlsglId }).then(rep => {
        if (rep.code == 1) {
          _this.ywList = rep.result.dlsgl.ywList || [];
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
    // 搜索数据
    searchJgglPage() {
      this.page.page = 1;
      this.findJgglPage();
    },
    // 获取数据
    findJgglPage() {
      var _this = this;
      var params = {
        dlsglId: _this.dlsglId,
        zhzt: _this.zhzt,
        jgmc: _this.jgmc,
        page: _this.page.page - 1,
        size: _this.page.size
      }
      _this.loading = true;
      _this.$post("jggl/JgglController/jgglPage", params).then(async rep => {
        _this.loading = false;
        if (rep.code == 1) {
          _this.tableData = rep.result.page.content;
          _this.page.total = rep.result.page.totalElements;
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
    showSaveJggl(id){
      var _this = this;
      if(id){
				_this.isAdd = false;
        _this.isEdit = true;
        _this.$post("jggl/JgglController/jgglView", { id: id }).then(rep => {
          if (rep.code == 1) {
            var jggl = rep.result.jggl;
            _this.ruleForm.id = jggl.id;
            _this.ruleForm.jgmc = jggl.jgmc;
            _this.ruleForm.jglxId = jggl.jglxId;
            _this.ruleForm.jglxmc = jggl.jglxmc;
            _this.ruleForm.fzr = jggl.fzr;
            _this.ruleForm.sjh = jggl.sjh;
            _this.ruleForm.dz = jggl.dz;
            _this.ruleForm.sxjf = jggl.sxjf;
            // 处理业务列表
            if (jggl.ywList && jggl.ywList.length > 0) {
              _this.selectedYwIds = jggl.ywList.map(item => item.ywcode);
              _this.originalYwIds = [..._this.selectedYwIds]; // 保存原始选中的业务ID
              _this.ruleForm.ywList = _this.selectedYwIds; // 用于校验
              _this.ywRsMap = {};
              jggl.ywList.forEach(item => {
                _this.$set(_this.ywRsMap, item.ywcode, item.rs || 0);
              });
            } else {
              _this.selectedYwIds = [];
              _this.originalYwIds = [];
              _this.ruleForm.ywList = [];
              _this.ywRsMap = {};
            }
          }
        })
      }else{
				_this.isAdd = true;
        _this.isEdit = false;
        _this.selectedYwIds = [];
        _this.originalYwIds = [];
        _this.ruleForm.ywList = [];
        _this.ywRsMap = {};
			}
      _this.jgglSaveDialog = true;
    },
		//代理商保存
		jgglSave() {
			var _this = this;
			_this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					_this.ruleForm.jglxmc = '';
					_this.jglxList.forEach(item=>{
						if(item.id === _this.ruleForm.jglxId){
							_this.ruleForm.jglxmc = item.lxmc
						}
					})
          // 构建业务列表数据
          const ywList = [];
          _this.selectedYwIds.forEach(ywcode => {
            ywList.push({
              ywcode: ywcode,
              rs: _this.ywRsMap[ywcode] || 0
            });
          });
          _this.ruleForm.ywList = ywList;
					_this.$post("jggl/JgglController/jgglSave", _this.ruleForm,'json').then(rep => {
						if (rep.code == 1) {
							_this.$message({
								type: "success",
								message: '保存成功'
							})
							_this.handleClose();
							_this.findJgglPage();
						} else {
              // 恢复ywList为数组以便校验（如果需要）
              _this.ruleForm.ywList = _this.selectedYwIds;
              _this.$message({
                type: "error",
                message: rep.msg
              });
            }
					})
				}
			})
		},
		// 撤回弹窗关闭时
		handleClose() {
      this.ruleForm = {
        jgbm: '',
        jgmc: '',
        jglxId: '',
        jglxmc: '',
        fzr: '',
        sjh: '',
        dz: '',
        dlsglId: sessionStorage.getItem("dlsglId"),
        ywList: []
      }
      this.selectedYwIds = [];
      this.originalYwIds = [];
      this.ywRsMap = {};
      this.isEdit = false;
      this.jgglSaveDialog = false;
			this.$refs.ruleForm.resetFields();
		},
    //显示积分记录
    showJgJfList(id){

    },
    // 禁用启用
    jgglZtEdit(id,zhzt){
      var message = zhzt==1?'启用':'禁用';
      this.$confirm('是否确认'+message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("jggl/JgglController/jgglZtEdit", { id:id,zhzt:zhzt }).then(rep => {
          if (rep.code == '1') {
            this.$message({
              type: "success",
              message: message+'成功'
            });
            this.findJgglPage();
          } else {
            this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      })
    },
		// 删除
		jgglDel(id) {
			this.$confirm('是否确认删除', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$post("jggl/JgglController/jgglDel", { id: id }).then(rep => {
					if (rep.code == '1') {
						this.$message({
							type: "success",
							message: '删除成功'
						});
						this.findJgglPage();
					} else {
						this.$message({
							type: "error",
							message: rep.msg
						});
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});
			})
		},
		// 每页条数
		handleSizeChange(val) {
			this.page.size = val;
			this.findJgglPage();
		},
		// 当前页
		handleCurrentChange(val) {
			this.page.page = val;
			this.findJgglPage();
		},
    jgglExport(){
      var access_token = sessionStorage.getItem("access_token");
      let url = "api/jggl/JgglController/jgglExport";
      url = url + "?access_token=" + access_token
          +"&dlsglId="+this.dlsglId
          +"&zhzt="+this.zhzt
          +"&jgmc="+this.jgmc;
      window.location.href = url;
    },

	},
}
</script>

<style lang="less">
.school-manage {
  .el-table::before {
    display: none;
  }
	.search {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 10px;
		.el-select,
		.el-input {
			margin-right: 10px;
		}
	}

	.el-button--text {
		padding: 0
	}

	.el-pagination {
		height: 36px;
		text-align: right;
		margin-top: 20px;
	}
	.content{
		display: flex;
		flex-wrap: wrap;
		margin: 0 20px;
		.listData{
			width: 200px;
			margin-right: 80px;
			margin-bottom: 40px;
			.zt{
				border: 1px solid #ccc;
				background-color: #F2F2F2;
				border-radius: 5px;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 150px;
				height: 70px;
				font-size: 16px;
				position: relative;
				i{
					position: absolute;
					left: 5px;
					top: -20px;
				}
				.el-icon-success{
					color: #67C23A;
				}
				.el-icon-error{
					color: #F56C6C;
				}
				.jiantou{
					position: absolute;
					right: -100px;
					width: 80px;
					height: 3px;
					background-color: #7F7F7F;
					display: flex;
					justify-content: end;
					align-items: center;
					span{
						position: absolute;
						right: -20px;
						width: 0;
						height: 0;
						border-style: solid;
						border-width: 10px 15px;
						border-color: transparent transparent transparent #7F7F7F;

					}
				}	
			}
			.mc{
				font-size: 14px;
				color: #7F7F7F;
				margin: 10px 0 3px;
			}
			.sj{
				font-size: 14px;
				color: #7F7F7F;
			}
		}
	}
	.xqtcCls{
		header{
			height: 50px;
			display: flex;
			align-items: center;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			padding: 0 30px;
			border-bottom: 1px solid #DCDFE6;
			span{
				font-weight: 500;
				font-size: 18px;
				color: #454545;
				margin-right: 25px;
			}
			div{
				padding: 0 8px;
				height: 28px;
				border-radius: 5px;
				font-weight: 400;
				font-size: 16px;
				color: #FFFFFF;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			.shtg{
				background: #4CAF50;
			}
			.shbtg{
				background: #FA5151;
			}
			.wtj{
				background: #757575;
			}
			.shz{
				background: #FF9800;
			}
			.cha{
				width: 16px;
				position: absolute;
				right: 30px;
				cursor: pointer;
			}
		}
	}
}
</style>
